<div class="tree-filter-container" (click)="$event.stopPropagation();">

	<div class="tree-search-wrap">
		<input class="tree-search-input" placeholder="Advisor (Team/Rep Id) Search" [formControl]="searchControl" />
		<mat-icon class="tree-search-icon">search</mat-icon>
	</div>

	<div class="tree-scroll-area">
		<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
			<mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="24">
				<span class="tree-toggle-spacer"></span>
				<mat-checkbox class="tree-checkbox"
					[checked]="checklistSelection.isSelected(node)"
					(change)="checklistSelection.toggle(node);">{{node.item}}
				</mat-checkbox>
			</mat-tree-node>
			<mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="24">
				<button type="button" matTreeNodeToggle class="tree-toggle-btn">
					<mat-icon>{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
				</button>
				<mat-checkbox class="tree-checkbox"
					[checked]="descendantsAllSelected(node)"
					[indeterminate]="descendantsPartiallySelected(node)"
					(change)="todoItemSelectionToggle(node)">{{node.item}}
				</mat-checkbox>
			</mat-tree-node>
		</mat-tree>
	</div>

	<div class="tree-footer">
		<button class="tree-footer-link" (click)="clearAll()">Clear All</button>
		<div class="tree-footer-actions">
			<button class="tree-btn tree-btn-cancel" (click)="cancel()">Cancel</button>
			<button class="tree-btn tree-btn-apply" (click)="applyFilter()">Apply</button>
		</div>
	</div>
</div>